var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { defineStore } from "pinia";
import { FilterItemTypes } from "./types";
import { computed, ref, toRaw } from 'vue';
export var useFilterStore = defineStore('filterStore', function () {
    var config = ref({});
    var values = ref({});
    var instance = ref(0);
    var active = computed(function () { return Object.keys(values.value).length > 0; });
    var enabled = ref(true);
    var loaded = ref(false);
    var items = ref([]);
    var sort = ref({
        default: 'hot',
        type: 'hot',
        types: {},
    });
    var available = computed(function () {
        var e_1, _a, e_2, _b;
        var available = {};
        try {
            for (var _c = __values(items.value), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                if (item.type === FilterItemTypes.Flag) {
                    available[item.name] = item.available;
                }
                if (item.type === FilterItemTypes.Range) {
                    available[item.name] = toRaw(item.available);
                }
                if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                    try {
                        for (var _e = (e_2 = void 0, __values(item.options)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var option = _f.value;
                            if (!available[item.name]) {
                                available[item.name] = {};
                            }
                            available[item.name][option.name] = option.available;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return available;
    });
    function disable() {
        enabled.value = false;
    }
    function setLoaded(isLoaded) {
        if (isLoaded === void 0) { isLoaded = true; }
        loaded.value = isLoaded;
    }
    function setInitialState(state) {
        config.value = state.config;
        values.value = state.values;
        setValues(state.values);
    }
    function setValues(filterValues) {
        var e_3, _a, e_4, _b;
        var _c, _d;
        try {
            for (var _e = __values(items.value), _f = _e.next(); !_f.done; _f = _e.next()) {
                var item = _f.value;
                var value = (_c = filterValues[item.name]) === null || _c === void 0 ? void 0 : _c.split('-');
                if ((_d = filterValues[item.name]) === null || _d === void 0 ? void 0 : _d.match(/^[\d-]+$/)) {
                    value = value.map(function (v) { return parseInt(v); });
                }
                if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                    item.active = !!(value === null || value === void 0 ? void 0 : value.length);
                    try {
                        for (var _g = (e_4 = void 0, __values(item.options)), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var option = _h.value;
                            option.selected = !!(value === null || value === void 0 ? void 0 : value.includes(option.value));
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
                else if (item.type === FilterItemTypes.Flag) {
                    item.active = value !== undefined;
                }
                else if (item.type === FilterItemTypes.Range) {
                    if (value === null || value === void 0 ? void 0 : value.length) {
                        var _j = __read(value, 2), min = _j[0], max = _j[1];
                        item.active = true;
                        item.value.min = parseInt(min);
                        item.value.max = parseInt(max);
                    }
                    else {
                        item.active = false;
                    }
                }
                else if (item.type === FilterItemTypes.Text) {
                    item.value = filterValues[item.name] || '';
                    item.active = !!item.value;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
    function update(newItems) {
        var oldExpanded = Object.fromEntries(items.value.map(function (item) { var _a; return [item.name, (_a = item.expanded) !== null && _a !== void 0 ? _a : false]; }));
        items.value = newItems.map(function (item) {
            var _a;
            return (__assign(__assign({}, item), { expanded: (_a = oldExpanded[item.name]) !== null && _a !== void 0 ? _a : false }));
        });
        enabled.value = !!newItems.length;
    }
    function updateValues() {
        var e_5, _a, e_6, _b;
        var result = {};
        try {
            for (var _c = __values(items.value), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                    var options = [];
                    try {
                        for (var _e = (e_6 = void 0, __values(item.options)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var option = _f.value;
                            if (option.selected) {
                                options.push(option.value);
                            }
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                    if (options.length) {
                        result[item.name] = options.join('-');
                        item.active = true;
                    }
                    else {
                        item.active = false;
                    }
                }
                if (item.type === FilterItemTypes.Flag) {
                    if (item.active) {
                        result[item.name] = true;
                    }
                }
                if (item.type === FilterItemTypes.Range) {
                    if (item.value.min === item.available.min && item.value.max === item.available.max) {
                        item.active = false;
                        continue;
                    }
                    if (item.value.min === 0 && item.value.max === 0) {
                        item.active = false;
                        continue;
                    }
                    result[item.name] = "".concat(item.value.min, "-").concat(item.value.max);
                    item.active = true;
                }
                if (item.type === FilterItemTypes.Text) {
                    if (item.value && item.value.trim() !== '') {
                        result[item.name] = item.value.trim();
                        item.active = true;
                    }
                    else {
                        item.active = false;
                    }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        values.value = result;
    }
    function updateAvailable(available) {
        var e_7, _a, e_8, _b;
        var _c, _d;
        try {
            for (var _e = __values(items.value), _f = _e.next(); !_f.done; _f = _e.next()) {
                var item = _f.value;
                if (item.type === FilterItemTypes.Flag) {
                    item.available = available[item.name];
                }
                if (item.type === FilterItemTypes.Range) {
                    item.available = available[item.name];
                }
                if (item.type === FilterItemTypes.List || item.type === FilterItemTypes.FilterableList) {
                    try {
                        for (var _g = (e_8 = void 0, __values(item.options)), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var option = _h.value;
                            option.available = (_d = (_c = available[item.name]) === null || _c === void 0 ? void 0 : _c[option.name]) !== null && _d !== void 0 ? _d : false;
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_7) throw e_7.error; }
        }
    }
    function setDefaultSort(defaultSort) {
        sort.value.default = defaultSort;
    }
    function setSortType(newSort) {
        sort.value.type = newSort;
        config.value.sort = newSort;
    }
    function setSortTypes(newSortTypes) {
        sort.value.types = newSortTypes;
    }
    function saveExpandedStateToSession() {
        var e_9, _a;
        var expanded = {};
        try {
            for (var _b = __values(items.value), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                expanded[item.name] = !!item.expanded;
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
        var state = {
            mode: config.value.mode,
            id: config.value.id,
            expanded: expanded,
        };
        sessionStorage.setItem('filterExpanded', JSON.stringify(state));
    }
    function restoreExpandedStateFromSession() {
        var e_10, _a;
        var _b, _c;
        var raw = sessionStorage.getItem('filterExpanded');
        if (!raw)
            return;
        try {
            var state = JSON.parse(raw);
            // Проверяем, соответствует ли mode и id текущему фильтру
            if (state.mode !== config.value.mode || state.id !== config.value.id) {
                sessionStorage.removeItem('filterExpanded');
                return;
            }
            try {
                // Восстанавливаем состояние открытых фильтров
                for (var _d = __values(items.value), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    item.expanded = (_c = (_b = state.expanded) === null || _b === void 0 ? void 0 : _b[item.name]) !== null && _c !== void 0 ? _c : false;
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        catch (e) {
            console.warn('Ошибка при восстановлении expanded', e);
            sessionStorage.removeItem('filterExpanded');
        }
    }
    return {
        // State
        config: config,
        values: values,
        instance: instance,
        active: active,
        enabled: enabled,
        loaded: loaded,
        items: items,
        sort: sort,
        available: available,
        // Methods
        disable: disable,
        setLoaded: setLoaded,
        setInitialState: setInitialState,
        setValues: setValues,
        update: update,
        updateValues: updateValues,
        setDefaultSort: setDefaultSort,
        setSortType: setSortType,
        setSortTypes: setSortTypes,
        saveExpandedStateToSession: saveExpandedStateToSession,
        restoreExpandedStateFromSession: restoreExpandedStateFromSession,
        updateAvailable: updateAvailable,
    };
});
